var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuitableForEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeWidth: 1.25,
  clipPath: "url(#suitableForEvents_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M18.338 19.158c.897-.897.17-3.078-1.624-4.872s-3.976-2.521-4.873-1.624-.17 3.078 1.624 4.872 3.976 2.521 4.873 1.624"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m11.475 13.488-5.698 9.994a1.313 1.313 0 0 0 1.743 1.742l9.993-5.694M16.25 5.656a12.1 12.1 0 0 1-.465 4.918M19.498 6.861l-.464 2.32M25.343 14.75a12.1 12.1 0 0 0-4.917.465M24.138 11.502l-2.32.464"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.073 9.51a.328.328 0 0 1 0-.656M12.073 9.51a.328.328 0 1 0 0-.656M18.57 12.295a.328.328 0 1 1 0-.656M18.57 12.295a.328.328 0 1 0 0-.656M22.282 8.582a.328.328 0 1 1 0-.656M22.282 8.582a.328.328 0 1 0 0-.656M22.282 17.863a.328.328 0 1 1 0-.656M22.282 17.863a.328.328 0 1 0 0-.656"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "suitableForEvents_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 5h21v21H5z"
})))));
export default SvgSuitableForEvents;